import React, {useEffect, useRef, useState} from 'react';
import {
	IconArrowLeftSvg,
	IconArrowRightSvg,
	StarSvg,
} from "../common/svg"
import {
	shuffle,
} from '../../helpers/data-helpers';
import { testimonialData } from '../../data/testimonials';

import '../../styles/shop/testimonials-carousel.scss';

const TestimonialsCarousel = () => {
	const [slidePosition, setSlidePosition] = useState(0);
	const [carouselData, setCarouselData] = useState([]);

	const carouselRef = useRef(null);
	const clipperRef = useRef(null);

	const slideWidth = () => {
		const carousel = carouselRef.current;
		if (!carousel) return 0;

		const cells = carousel.querySelectorAll('div.testimonial-cell');
		if (cells.length === 0) return 0;

		const gap = parseInt(window.getComputedStyle(carousel).columnGap) || 0;
		return cells[0].offsetWidth + gap;
	}

	const positionCarousel = () => {
		const carousel = carouselRef.current;
		if (!carousel) return;

		const width = slideWidth();
		if (width === 0) return;

		carousel.style.transform = `translateX(-${slidePosition * width}px)`;
	};

	const stepCarousel = (step) => {
		const carousel = carouselRef.current;
		const clipper = clipperRef.current;
		if (!carousel || !clipper) return;

		const cells = carousel.querySelectorAll('div.testimonial-cell');
		if (cells.length === 0) return;

		const width = slideWidth();
		if (width === 0) return;

		const steppedPosition = slidePosition + step;
		const slideOffset = Math.ceil(clipper.offsetWidth / width);

		if (steppedPosition < 0) {
			setSlidePosition(cells.length - slideOffset);
		} else if (steppedPosition > cells.length - slideOffset) {
			setSlidePosition(0);
		} else {
			setSlidePosition(steppedPosition);
		}
	};

	useEffect(() => {
		positionCarousel();
	}, [slidePosition]);

	useEffect(() => {
		if (testimonialData.length > 0) {
			setCarouselData(shuffle([...testimonialData]));
		}

		const handleResize = () => {
			// Debounce the resize handler
			if (window.resizeTimer) {
				clearTimeout(window.resizeTimer);
			}
			window.resizeTimer = setTimeout(() => {
				positionCarousel();
			}, 100);
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
			if (window.resizeTimer) {
				clearTimeout(window.resizeTimer);
			}
		};
	}, []);

	return (
		<div className="testimonials-carousel-container">
			<div
				ref={clipperRef}
				className="testimonials-carousel-clipper"
			>
				<div
					ref={carouselRef}
					className="testimonials-carousel"
				>
					{carouselData.map((testimonial, index) => (
						<div
							key={`${testimonial.name}-${index}`}
							className="testimonial-cell"
						>
							<div className="star-bar">
								{Array.from({length: testimonial.stars}, () => <>{StarSvg}</>)}
							</div>
							<p className="message">
								{testimonial.message}
							</p>
							<p className="attribution">
								{testimonial.name}<br />
								{testimonial.town}, {testimonial.country}
							</p>
						</div>
					))}
				</div>
			</div>

			<div className="button-bar">
				<button
					className="back-button direction-button"
					onClick={() => stepCarousel(-1)}
					aria-label="Scroll Testimonials Back"
				>
					{IconArrowLeftSvg}
				</button>
				<button
					className="forward-button direction-button"
					onClick={() => stepCarousel(1)}
					aria-label="Scroll Testimonials Forward"
				>
					{IconArrowRightSvg}
				</button>
			</div>
		</div>
	);
};

export default TestimonialsCarousel;